import React from 'react';
import Toast from '../common/Toast';
import { NotificationCenter } from '../utils/types';

export default class BulkActionCancelToast extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      display: false
    };

    this.showToast = this.showToast.bind(this);
    this.onTimeout = this.onTimeout.bind(this);
  }

  onTimeout(){
    this.setState({ display: false });
  }

  componentDidMount() {
    this.props.notificationCenter.addListener('batchactionsenttoast', this.showToast);
  }

  componentWillUnmount() {
    this.props.notificationCenter.removeListener('batchactionsenttoast', this.showToast);
  }

  showToast() {
    this.setState({ display: true });
  }

  render() {
    
    if(!this.state.display) return null;

    return <Toast        
        message="Your batch send job was canceled."
        onTimeout={this.onTimeout}        
      />;
  }
}

BulkActionCancelToast.propTypes = {
  notificationCenter: NotificationCenter.isRequired,
};
